import { stringSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';

import { PublicPage } from '@/app/PublicPage';
import { PublicCustomerLandingPage } from '@/areas/customers/CustomerLanding/pages/PublicCustomerLandingPage';
import type { PageStaticData } from '@/shared/routing';
import { browserLanguageLoaded } from '@/shared/utils/internationalisation';

export const Route = createFileRoute('/landing')({
    staticData: { access: 'public', chrome: 'none' } satisfies PageStaticData,
    validateSearch: stringSearch({}),
    loader: () => browserLanguageLoaded(),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return (
        <PublicPage>
            <PublicCustomerLandingPage />
        </PublicPage>
    );
}
